export const widgetRegistry = {

/* =================================================
   QSR / CANTEEN MONITORING
================================================= */

"table-occupancy": { 
  title:"Table Occupancy", 
  type:"card" 
},

"occupied-table-count": { 
  title:"Occupied Tables", 
  type:"card" 
},

"available-table-count": { 
  title:"Available Tables", 
  type:"card" 
},

"mobile-usage-alerts": { 
  title:"Mobile Usage Alerts", 
  type:"card" 
},

"table-usage-report": { 
  title:"Table Usage Trend", 
  type:"graph" 
},

"mobile-usage-report": { 
  title:"Mobile Usage Trend", 
  type:"graph" 
},

"occupancy-history": { 
  title:"Occupancy History", 
  type:"graph" 
},

/* =================================================
   CORE KPI CARDS
================================================= */

"live-occupancy": { title:"Live Occupancy", type:"card" },
"live-count": { title:"Live Count", type:"card" },
"mobile-usage": { title:"Mobile Usage", type:"card" },
"total-alerts": { title:"Total Alerts", type:"card" },
"violation-count": { title:"Violation Count", type:"card" },
"status-indicator": { title:"System Status", type:"card" },
"active-cameras": { title:"Active Cameras", type:"card" },
"recent-alerts": { title:"Recent Alerts", type:"card" },
"alert-list": { title:"Alert List", type:"card" },
"entry-exit-count": { title:"Entry / Exit Count", type:"card" },
"zone-wise-count": { title:"Zone-wise Count", type:"card" },
"unsafe-proximity-count": { title:"Unsafe Proximity", type:"card" },

/* =================================================
   OPERATIONAL KPI
================================================= */

"staff-utilization": { title:"Staff Utilization", type:"card" },
"productivity-score": { title:"Productivity Score", type:"card" },
"compliance-score": { title:"Compliance Score", type:"card" },
"risk-score": { title:"Risk Score", type:"card" },
"peak-hour": { title:"Peak Hour", type:"card" },
"queue-abandon-rate": { title:"Queue Abandon Rate", type:"card" },
"anomaly-rate": { title:"Anomaly Rate", type:"card" },
"machine-health-score": { title:"Machine Health", type:"card" },
"fatigue-score": { title:"Fatigue Score", type:"card" },
"visitor-count": { title:"Visitor Count", type:"card" },
"asset-utilization": { title:"Asset Utilization", type:"card" },

/* =================================================
   PARKING (ADDED FROM PREVIEW)
================================================= */

"parking-utilisation": { title:"Parking Utilisation", type:"card" },
"occupancy-score": { title:"Occupancy Score", type:"card" },
"occupancy-table": { title:"Occupancy Table", type:"card" },

"vehicle-entry-count": { title:"Vehicle Entry Count", type:"card" },
"vehicle-exit-count": { title:"Vehicle Exit Count", type:"card" },
"current-vehicle-count": { title:"Current Vehicle Count", type:"card" },
"traffic-load": { title:"Traffic Load", type:"card" },
"vehicle-log": { title:"Vehicle Log", type:"card" },

"illegal-parking-count": { title:"Illegal Parking Count", type:"card" },
"violation-zones": { title:"Violation Zones", type:"graph" },
"violation-log": { title:"Violation Log", type:"card" },

"avg-parking-duration": { title:"Average Parking Duration", type:"card" },
"overstay-vehicles": { title:"Overstay Vehicles", type:"card" },
"duration-distribution": { title:"Duration Distribution", type:"graph" },
"duration-trend": { title:"Duration Trend", type:"graph" },
"overstay-report": { title:"Overstay Report", type:"card" },

/* =================================================
   INDUSTRY SPECIFIC
================================================= */

"throughput-rate": { title:"Throughput Rate", type:"card" },
"idle-vs-active": { title:"Idle vs Active", type:"card" },
"available-slots": { title:"Available Slots", type:"card" },
"occupied-slots": { title:"Occupied Slots", type:"card" },
"avg-dwell-time": { title:"Average Dwell Time", type:"card" },
"queue-length": { title:"Queue Length", type:"card" },

/* =================================================
   ANALYTICS / GRAPHS
================================================= */

"trend-graph": { title:"Trend Analysis", type:"graph" },
"zone-breakdown": { title:"Zone Breakdown", type:"graph" },
"people-count-analytics": { title:"People Count Analytics", type:"graph" },
"crowd-levels": { title:"Crowd Levels", type:"graph" },
"parking-duration": { title:"Parking Duration", type:"graph" },
"attendance-trend": { title:"Attendance Trend", type:"graph" },
"compliance-trend": { title:"Compliance Trend", type:"graph" },
"heatmap-visualization": { title:"Heatmap Visualization", type:"graph" },
"hourly-activity-graph": { title:"Hourly Activity", type:"graph" },
"zone-comparison-chart": { title:"Zone Comparison", type:"graph" },
"shift-performance": { title:"Shift Performance", type:"graph" },
"queue-time-distribution": { title:"Queue Time Distribution", type:"graph" },
"incident-distribution": { title:"Incident Distribution", type:"graph" },
"customer-flow-sankey": { title:"Customer Flow", type:"graph" },
"heatmap-timeline": { title:"Heatmap Timeline", type:"graph" },
"anomaly-trend": { title:"Anomaly Trend", type:"graph" },

/* =================================================
   TABLES / LISTS
================================================= */

"vehicle-log-table": { title:"Vehicle Logs", type:"card" },
"incident-table": { title:"Incident Table", type:"card" },
"visitor-log-table": { title:"Visitor Logs", type:"card" },
"staff-performance-table": { title:"Staff Performance", type:"card" },
"machine-health-table": { title:"Machine Health Table", type:"card" },
"asset-log-table": { title:"Asset Logs", type:"card" },
"shelf-status-table": { title:"Shelf Status", type:"card" },

/* =================================================
   SYSTEM / MAINTENANCE
================================================= */

"maintenance-status": { title:"Maintenance Status", type:"card" },

/* =================================================
   AI INSIGHTS
================================================= */

"ai-insights": { title:"AI Insights", type:"card" },
"optimization-suggestions": { title:"Optimization Suggestions", type:"card" },

/* =================================================
   EDUCATION
================================================= */

"staff-entry-count": { title:"Staff Entry Count", type:"card" },

"staff-exit-count": { title:"Staff Exit Count", type:"card" },

"staff-inside-count": { title:"Staff Inside Campus", type:"card" },

"late-staff-count": { title:"Late Staff Today", type:"card" },

"early-exit-count": { title:"Early Exit Count", type:"card" },

"most-active-staff": { title:"Most Active Staff", type:"card" },

"least-active-staff": { title:"Least Active Staff", type:"card" },

"staff-attendance-trend": { title:"Staff Attendance Trend", type:"graph" },

"hourly-entry-trend": { title:"Hourly Entry Trend", type:"graph" },

"hourly-exit-trend": { title:"Hourly Exit Trend", type:"graph" },

"weekly-attendance-trend": { title:"Weekly Attendance Trend", type:"graph" },

"staff-working-hours-chart": { title:"Working Hours Distribution", type:"graph" },

"gate-entry-exit-log": { title:"Gate Entry Exit Logs", type:"table" },

"staff-entry-exit-summary": { title:"Staff Entry Exit Summary", type:"table" },

"staff-working-hours-table": { title:"Staff Working Hours", type:"table" },

"late-staff-table": { title:"Late Staff List", type:"table" },
};